module.exports = "/_next/static/images/6449343509837555313b2dbe6cf7f6b2-woman-with-iphone@3x.jpg";